export interface TmemberType {
    id?: number,
    name: string,
    code: string,
    className: string,
    active: string,
    view: string
}

export const initialMemberType: TmemberType = {
    name: "",
    code: "",
    className: "",
    active: "",
    view: ""
}